import { createCommonFlowResolvers } from './base/createCommonFlowResolvers';
import { runFlow } from './base/runFlow';

export async function runCustomFlow(flowResolverKeys: string[]) {
  const flowResolvers = createCommonFlowResolvers();
  await runFlow(flowResolverKeys, flowResolvers);
}
